import APIRequest from "../../../../Services/commonAPIConsumer";
import { useDispatch } from "react-redux";
import { storeLookupData } from "../../../../StateManagement/actions";
import { useNavigate } from "react-router-dom";

export function useFetchLookupData() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  async function fetchLookupData() {
    try {
      const url = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetLookUpDetails}`;
      const response = await APIRequest.GET(
        "",
        `${url}?Lang=${localStorage.getItem("language")}`
      );
      if (response === "Server maintenance") {
        navigate("/maintenance");
        return;
      }
      if (!response || response === "Failed to fetch") {
        // setAlertMsg(
        //   selectedLanguage.LstLanguageCodes.UI_FailedtoSaveSetting + "."
        // );
        // setAlertType("warning");
        return;
      }
      const timeZoneAbbrevation = localStorage.getItem("timeZoneAbbrevation") ? localStorage.getItem("timeZoneAbbrevation") :  "UTC" ;
      const options1 = [];
      response.bindLookUpData
        .filter((data) => data.fieldName === "BannedRegions")
        .forEach((option) =>
          options1.push({ value: option.key, label: option.keyValue })
        );

      const uniqueBannedRegions = options1.filter(
        (item, index, self) => index === self.findIndex((t) => t.value === item.value)
      );

      const landingPageData = {
        isManageOption: false,
        selectedLandingOption: "",
      };
      const TimeZoneOptions = response.bindLookUpData.filter(
        (data) => data.fieldName === "TimeZone"
      );
       const PasscodeLengthOptions = response.bindLookUpData.filter(
        (data) => data.fieldName === "PasscodeLength"
      );
      // const IDLeakersTypeOptions = response.bindLookUpData.filter(
      //   (data) => data.fieldName === "IDLeakersType"
      // );
     const landingPageOptions = {
        landingOptions: response.bindLookUpData
          .filter(
            (data) =>
              data.fieldName === "LandingPage" &&
              !data.key.includes("ManageItem")
          )
          .map((data) => data),
        manageOptions: response.bindLookUpData
          .filter(
            (data) =>
              data.fieldName === "LandingPage" &&
              data.key.includes("ManageItem")
          )
          .map((data) => ({
            ...data,
            key: data.key.split('_')[1]
          })),
      };

      dispatch(storeLookupData({
        dateFormatOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "DateFormat"
        ),
        serviceLanguageOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "ServiceLanguage"
        ).sort((a, b) => a.keyValue.localeCompare(b.keyValue)),

        appLanguageOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "AppLanguage"
        ).sort((a, b) => a.keyValue.localeCompare(b.keyValue)),
        
        gatewayOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "Gateway"
        ),
        accessControlOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "AccessControl"
        ),
         launchesOptions: response.bindLookUpData
    .filter((data) => data.fieldName === "Launches")
    .map((item) => ({
      ...item,
      keyValue: item.keyValue.replace(
        /\bUTC\b/g,
        timeZoneAbbrevation || "UTC"
      )
    })),
        IDLeakersTypeOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "IDLeakersType"
        ),
        watermarkOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "Watermark"
        ),
        maxPagesPerRPDOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "MaxPagesPerRPD"
        ),
        passcodeExpiryPolicyOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "PasscodeExpiryPolicy"
        ),
        imageResolutionOptions: response.bindLookUpData.filter(  
          (data) => data.fieldName === "ImageResolution"
        ),
        roleOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "RoleNames"
        ),
        defaultSettingsForOptions:response.bindLookUpData.filter(
              (data) => data.fieldName === "DefaultSettingsFor"
            ),
        bannedRegionOptions: uniqueBannedRegions,
        cipherTextOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "CipherText"
        ),
        opacityOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "Opacity"
        ),
        cipherViewOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "CipherView"
        ),
        cipherPatternOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "CipherPattern"
        ),
        shapeOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "Shape"
        ),
        floatingTextOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "FloatingText"
        ),
        suffixPrefixOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "SuffixPrefixFloatingText"
        ),
        navigationOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "Navigation"
        ),
        fontColorOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "FontColor"
        ),
        fontSizeOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "FontSize"
        ),
        speedOptions: response.bindLookUpData.filter(
          (data) => data.fieldName === "Speed"
        ),
        directSendDefault: response.isDirectSendDefault === "true",
        landingPageData,
        landingPageOptions,
        TimeZoneOptions,
        PasscodeLengthOptions,
        // IDLeakersTypeOptions
      }));
    } catch (error) {
      throw error;
    }
  }

  return { fetchLookupData };
}


export default useFetchLookupData;